<template>
  <div class="course">
    <!-- <Modal
      v-if="components.info"
      v-on:dismiss="components.info = false"
      title="试听须知"
      :showComplete="false"
      :showClose="true"
      :tapToDismiss="true"
    >
      <Info date="2020-08-01 00:00" />
      <div class="button" @click="order">我明白试听要求，确认预约</div>
    </Modal>-->
    <div
      v-for="item in courses"
      @click="cd_id = item.cd_id"
      :class="{ selected: cd_id === item.cd_id }"
      class="course-item"
      :key="item.cd_id"
    >
      <div class="left">
        <h1>{{ item.desc }}</h1>
        <p>{{ item.title }}</p>
      </div>
      <i class="right anyteachicon anyteach-check-circle" />
    </div>
    <div class="button" @click="order">确认预约</div>
  </div>
</template>

<script>
import Info from "./Info"
export default {
  name: "Course",
  props: ["data"],
  components: {
    Info
  },
  data() {
    return {
      cd_id: null,
      components: {
        info: false
      }
    }
  },
  computed: {
    courses() {
      return JSON.parse(this.data.store_a.event_info.course_data)
    }
  },
  created() {
    this.cd_id = this.courses.find(item => item.default).cd_id
  },
  methods: {
    async order() {
      this.$toastLoading("正在预约...")
      const { code, msg } = await this.$api.storeGift.BUY_DEMO(this.cd_id)
      if (code === "1000") {
        this.$emit("complete")
        this.$toastSuccess("预约成功，请添加客服")
      } else {
        this.$toastError(msg)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.course-item {
  padding: 12px;
  background: #f7f7f7;
  margin: 0 0 10px 0;
  border: 1.5px solid #eee;
  border-radius: 4px;
  transition: all 0.1s;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .right {
    font-size: 1.1rem;
    opacity: 0.2;
  }
  h1 {
    font-size: 0.9rem;
    margin: 0;
    line-height: 1.5;
  }
  p {
    line-height: 1;
  }
}

.selected {
  border-color: $blue;
  .right {
    color: $blue;
    opacity: 1;
  }
}

.button {
  @include avenir-demi();
  width: 100%;
  text-align: center;
  background: $blue;
  border-radius: 4px;
  color: white;
  padding: 8px 0;
  font-size: 0.85rem;
  transition: all 0.1s;
  &:active {
    opacity: 0.6;
  }
}
</style>